import type { DashboardDateRange } from '@/components/dashboard/model';
import {
  dashboardRouteSearchSchema,
  parseDashboardRouteSearch,
  serializeDashboardRouteFilters,
  type DashboardRouteSearch,
} from '../../../dashboard/dashboardRouteSearch';

export type IntegrationDashboardRouteSearch = DashboardRouteSearch;

export function integrationDashboardRouteSearchSchema(search: Record<string, unknown>) {
  return dashboardRouteSearchSchema(search);
}

export function parseIntegrationDashboardRouteSearch(search: IntegrationDashboardRouteSearch) {
  return parseDashboardRouteSearch(search);
}

export function serializeIntegrationDashboardRouteFilters(range: DashboardDateRange) {
  return serializeDashboardRouteFilters({ range });
}
